import axios from 'axios';
import config from '../config/config';
const http = axios.create({
  validateStatus: function (status) {
    return status >= 200 && status < 500;
  },
});

export default class MailchimpService {
  private mailchimpUrl: string = config.mailchimp.url;
  private mailchimpAuth: string;
  private id: string = '7b37bd7975';

  constructor(mailchimpAuth: string) {
    this.mailchimpAuth = mailchimpAuth;
  }

  async getMembers() {
    const {
      data: { total_items },
    } = (
      await http.get(
        `${this.mailchimpUrl}/lists/${this.id}/members?auth=${this.mailchimpAuth}`
      )
    ).data;

    const {
      data: { members },
    } = (
      await http.get(
        `${this.mailchimpUrl}/lists/${this.id}/members?count=${total_items}&auth=${this.mailchimpAuth}`
      )
    ).data;

    const properMembers = members.filter(
      (member) => member.merge_fields.PUBKEY !== ''
    );
    return properMembers;
  }
}
